export default "__VITE_ASSET__6OKmYvPM__"